import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ImportantAlertPopupComponent, ImportantAlertPopupInput, ImportantAlertPopupResult } from './important-alert-popup.component';
import { ModalDialogService } from '../../modal-dialog/modal-dialog.service';

@NgModule({
  declarations: [ImportantAlertPopupComponent],
  imports: [
    CommonModule,
    MatIconModule
  ],
  providers: [
    ModalDialogService<ImportantAlertPopupResult, ImportantAlertPopupInput>
  ],
  exports: [ImportantAlertPopupComponent]
})
export class ImportantAlertPopupModule {}
